module.exports = __webpack_public_path__ + "school/img/videoTrainingDirectoryListBg.e366634d.png";